import React, { ComponentType } from 'react';
import { OptionProps } from 'react-select';

import styles from './FacebookTargetingLocations.module.css';
import { FacebookTargetingLocationSearchOption } from '../../../../../../../../App.types';

const FacebookTargetingLocationOption: ComponentType<OptionProps<FacebookTargetingLocationSearchOption, false>> = (
    props
) => {
    return (
        <div
            style={props.getStyles('option', props)}
            className={props.cx(
                {
                    option: true,
                    'option--is-disabled': props.isDisabled,
                    'option--is-focused': props.isFocused,
                    'option--is-selected': props.isSelected,
                },
                props.className
            )}
            ref={props.innerRef}
            {...props.innerProps}
        >
            <div className={styles.row}>
                <p className={styles.optionLabel}>{props.label}</p>
                <span className={styles.optionType}>{props.data.typeLabel}</span>
            </div>
        </div>
    );
};

export default FacebookTargetingLocationOption;
